<div class="p-5">
  <h1 class="mt-5">
    {{ 'LOGIN_PAGE.title' | translate }}
  </h1>
  <p class="mt-5">
    {{ 'LOGIN_PAGE.subtitle' | translate }}
  </p>
  <div class="d-flex justify-content-end mt-5 login-btn">
    <db-button class="login-btn" design="primary" (click)="onLogin()" [loading]="loginStarted">{{
        'GLOBAL.login_btn_txt' |
          translate
      }}
    </db-button>
  </div>
</div>
